export const Statuses = ['Accepted', 'Pending', 'Disabled'] as const;

export type Status = (typeof Statuses)[number];
